import { getUrl } from "utils";
import client from "utils/connected/api";

export const getQuotaTypesRequest = (filterParams) => client.get(getUrl("quota-types", filterParams));
